import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';
import BranchDetailLookup from '../../../Domain/Models/Catalogue/Reporting/Lookups/BranchDetailLookup';
import IssuerLookup from '../../../Domain/Models/Issuers/Lookups/IssuerLookup';
import Group from '../../../Domain/Models/Catalogue/Reporting/Group';

export default class ExposureCriteria extends Model.CriteriaBase {
    static typeName = "ExposureCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date = DateUtils.monthEnd(DateUtils.today());

    @Rules.Required()
    public entityId: number = 0;

    @Attributes.Nullable()
    public issuerId: number | null = null;

    @Attributes.Nullable()
    @Attributes.Display("Cluster Id")
    public groupId: number | null = null;

    @Attributes.Nullable()
    public businessUnitId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerName: string = "";

    @Attributes.NoTracking()
    public profitCentreName: string = "";

    @Attributes.NoTracking()
    public groupName: string = "";

    public setIssuer(issuer: Model.PlainObject<IssuerLookup> | undefined) {
        this.issuerId = issuer?.issuerId ?? null;
        this.issuerName = issuer?.issuerName ?? "";
    }

    public setProfitCentre(lookup: BranchDetailLookup | undefined) {
        this.businessUnitId = lookup?.businessUnitId ?? null;
        this.profitCentreName = lookup?.profitCentreName ?? "";
    }

    public setGroup(group: Group | undefined) {
        this.groupId = group?.groupId ?? null;
        this.groupName = group?.groupName ?? "";
    }

    protected static addBusinessRules(rules: Validation.Rules<ExposureCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Exposure Criteria";
    }
}